export const privacyCenterActionTypes = {
    CANCEL_MEMBERSHIP_START: 'CANCEL_MEMBERSHIP_START',
    CANCEL_MEMBERSHIP_REQUEST: 'CANCEL_MEMBERSHIP_REQUEST',
    CANCEL_MEMBERSHIP_SUCCESS: 'CANCEL_MEMBERSHIP_SUCCESS',
    CANCEL_MEMBERSHIP_FAILURE: 'CANCEL_MEMBERSHIP_FAILURE',

    GET_SERVICES_AND_CONSENTS_REQUEST: 'GET_SERVICES_AND_CONSENTS_REQUEST',
    GET_SERVICES_AND_CONSENTS_SUCCESS: 'GET_SERVICES_AND_CONSENTS_SUCCESS',
    GET_SERVICES_AND_CONSENTS_FAILURE: 'GET_SERVICES_AND_CONSENTS_FAILURE',

    LOAD_SERVICES_CONFIG_REQUEST: 'LOAD_SERVICES_CONFIG_REQUEST',
    LOAD_SERVICES_CONFIG_SUCCESS: 'LOAD_SERVICES_CONFIG_SUCCESS',
    LOAD_SERVICES_CONFIG_FAILURE: 'LOAD_SERVICES_CONFIG_FAILURE',

    LOAD_SERVICES_RECOMMENDATION_REQUEST: 'LOAD_SERVICES_RECOMMENDATION_REQUEST',
    LOAD_SERVICES_RECOMMENDATION_SUCCESS: 'LOAD_SERVICES_RECOMMENDATION_SUCCESS',
    LOAD_SERVICES_RECOMMENDATION_FAILURE: 'LOAD_SERVICES_RECOMMENDATION_FAILURE',

    UPDATE_CONSENT_REQUEST: 'UPDATE_CONSENT_REQUEST',
    UPDATE_CONSENT_SUCCESS: 'UPDATE_CONSENT_SUCCESS',
    UPDATE_CONSENT_FAILURE: 'UPDATE_CONSENT_FAILURE',

    GO_TO_RAKUTEN_SERVICE: 'GO_TO_RAKUTEN_SERVICE',

    OPEN_DSR_FORM: 'OPEN_DSR_FORM',
    CLOSE_DSR_FORM: 'CLOSE_DSR_FORM',

    DELETE_SERVICE_BTN_REQUEST: 'DELETE_SERVICE_BTN_REQUEST',
    DELETE_SERVICE_BTN_SUCCESS: 'DELETE_SERVICE_BTN_SUCCESS',
    DELETE_SERVICE_BTN_FAILED: 'DELETE_SERVICE_BTN_FAILED',

    TOGGLE_DSR_DELETE_STATUS_INFO: 'TOGGLE_DSR_DELETE_STATUS_INFO',

    UNLINK_SOCIAL_PROVIDER_REQUEST: 'UNLINK_SOCIAL_PROVIDER_REQUEST',
    UNLINK_SOCIAL_PROVIDER_SUCCESS: 'UNLINK_SOCIAL_PROVIDER_SUCCESS',
    UNLINK_SOCIAL_PROVIDER_FAILURE: 'UNLINK_SOCIAL_PROVIDER_FAILURE',

    OPEN_SOCIAL_UNLINK_FORM: 'OPEN_SOCIAL_UNLINK_FORM',
    CLOSE_SOCIAL_UNLINK_FORM: 'CLOSE_SOCIAL_UNLINK_FORM',
};

export const analyticsDestinations = {
    tc: 'Terms and Conditions',
    cp: 'Cookie Consent',
    pp: 'Privacy Policy',
};

export const defaultService = {
    name: 'Rakuten Service',
    logo: `${process.env.PUBLIC_URL}/assets/logo/logo_rakuten_01.svg`,
    labelKey: {
        intro: 'rakservice.intro.default',
        newsletter: 'rakservice.newsletter.default',
    },
    privacySettingsLink: 'https://dummyrakutentv',
    enableNewsletterManagement: true,
};
